export default __webpack_public_path__ + "static/media/ProductSans-Regular.18c3428d.woff";